module.exports = __webpack_public_path__ + "img/quiz.6994484c.svg";